"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PincodeGenerator = void 0;
// copied from teacher app: pinCodeLib.js
class PincodeGenerator {
    static generateNumericPin(size = 6) {
        return padInteger(Math.random() * Math.pow(10, size), size);
    }
    // generates a n-length code of lowercase characters
    // by default, starting with 'x' is prohibited for standard codes
    // @startWith is optional, for now only called with an 'x' for student re-login tokens by teachers
    static createAlphabeticCode(size = 5, startWith) {
        // possibleStart is the pool of characters to start with
        let possibleStart = 'abcdefghijklmnopqrstuvwyz'; // by default, do NOT start with x
        // possible is the pool of characters used in the string for all index nrs > 0
        const possible = 'abcdefghijklmnopqrstuvwxyz'; // yes, 26 chars, x included
        // if a starting character is given, use the full (given) possible pool list all the way
        if (startWith) {
            possibleStart = possible;
        }
        let text = startWith || '';
        for (let i = text.length; i < size; i++) {
            const pool = i == 0 ? possibleStart : possible;
            text += pool.charAt(Math.floor(Math.random() * pool.length));
        }
        return text;
    }
}
exports.PincodeGenerator = PincodeGenerator;
function padInteger(num, size) {
    return ('000000000' + Math.floor(num)).substr(-size);
}
//# sourceMappingURL=PincodeGenerator.js.map